import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'

import { SellTreez } from '@/models/sellTreez'
import { SellTreezService } from '@/services/sell-treez'

export const useGetAllSellTreez = () => {
  const queryKey = ['all-sell-treez']

  const getAllSellTreez = useCallback(async () => {
    const response = await SellTreezService.getAllSellTreez()
    return response.data as SellTreez[]
  }, [])

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: getAllSellTreez,
    refetchInterval: 5000,
  })

  return { sellTreez: data ?? [], isLoading, refetch }
}
